import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    IServerJobApplicationTrail,
    JobApplicationTrailActionTypes,
    IServerJobApplicationTrailParams,
    IServerJobApplicationTrailRelatedObject,
    getServerUserDisplayName,
} from '../../../../common';
import {
    StyledContainer,
    StyledDateText,
    StyledCommentContainer,
    StyledAvatar,
    StyledContent,
} from './TrailItem.styles';
import { Box, Typography } from '../../../../base';

interface Props {
    trailItem: IServerJobApplicationTrail;
    getTrailActionText(
        actionType: JobApplicationTrailActionTypes,
        params: IServerJobApplicationTrailParams,
        relatedObject: IServerJobApplicationTrailRelatedObject
    ): string;
}

const TrailItem = (props: Props) => {
    const { trailItem, getTrailActionText } = props;
    const { user, action_type, params, related_object, created_at } = trailItem;
    const { t } = useTranslation();

    const fullName =
        getServerUserDisplayName(user ?? undefined) || t('trail.systemUser');
    const userImage = user?.image;
    const actionText = getTrailActionText(action_type, params, related_object);
    const formattedDate = moment(created_at).format('h:mm A MMMM D');

    return (
        <StyledContainer container>
            <StyledAvatar name={fullName} src={userImage} />
            <StyledContent>
                <Box>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        {fullName}
                    </Typography>
                    <Typography
                        component="span"
                        sx={{ marginInlineStart: 0.5 }}
                    >
                        {actionText}
                    </Typography>
                </Box>
                <StyledDateText variant="caption">
                    {formattedDate}
                </StyledDateText>
                {action_type === JobApplicationTrailActionTypes.comment &&
                    related_object?.text && (
                        <StyledCommentContainer>
                            <Typography
                                variant="body2"
                                dir="auto"
                                sx={{ overflowWrap: 'break-word' }}
                            >
                                {related_object.text}
                            </Typography>
                        </StyledCommentContainer>
                    )}
            </StyledContent>
        </StyledContainer>
    );
};

export default TrailItem;
